import { jsx } from "react/jsx-runtime";
import ConstructionIcon from "@mui/icons-material/Construction";
import { validateTidalLicense } from "../../base/index.js";
function Construction(props) {
  return /* @__PURE__ */ jsx(
    ConstructionIcon,
    {
      "data-testid": "Construction",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Construction",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Construction.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Construction"
};
validateTidalLicense();
export {
  Construction
};
//# sourceMappingURL=Construction.js.map
